import Swiper, { Thumbs, Autoplay, Navigation, EffectFade } from 'swiper';

const swiperThumbsItems = new Swiper('.swiper-thumbs__items', {
    slidesPerView: 'auto',
    freeMode: true
});

const setProgress = (el, progress) => {
    el.style.setProperty('width', (1 - progress) * 100 + '%');
};

const swiperThumbs = new Swiper('.swiper-thumbs__slider', {
    modules: [Thumbs, Autoplay, Navigation, EffectFade],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    longSwipes: true,
    loop: true,
    watchSlidesProgress: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    thumbs: {
        swiper: swiperThumbsItems
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
            const progressEl = document.querySelector('.swiper-slide-active .swiper-slide__progress');
            const progressThumbsEl = document.querySelector('.swiper-slide-thumb-active .swiper-slide__progress');

            progressEl && setProgress(progressEl, progress);
            progressThumbsEl && setProgress(progressThumbsEl, progress);
        },
        init() {
            const slider = this.el.closest('.swiper-thumbs');
            const slides = slider.querySelectorAll('.swiper-thumbs__slider .swiper-slide');

            if (slides.length > 5) {
                slider.querySelector('.swiper-thumbs__items').style.display = 'none';
                slider.querySelector('.swiper-thumbs__slider .swiper-navigation-wrapper').style.display = 'block';
                slides.forEach((slide) => {
                    slide.querySelector('.swiper-slide__progress').style.display = 'block';
                });
            }
        }
    }
});
